'use strict';

class LabelEdit {
  constructor($location, $routeParams, labelService, recipientService, reportService) {
    this.$location = $location;
    this.labelService = labelService;
    this.recipientService = recipientService;
    this.reportService = reportService;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.label = {};
    this.recipientNumber = null;
    this.members = {
      items: [],
      total: 0
    };

    // autocomplete
    $('#recipientName').autocomplete({
      minLength: 1,
      source: (req, resp) => {
        this.recipientService.search(req.term, 10)
          .then((result) => {
            this.recipientNumber = null;
            let suggestions = [];

            $.each(result.data.recipients, (i, val) => {
              suggestions.push({
                value: val.name,
                label: val.name,
                number: val.number
              });
            });

            resp(suggestions);
          });
      },
      select: (e, ui) => {
        if (ui.item !== null || ui.item !== 'null') {
          this.recipientNumber = ui.item.number;
        }
      }
    });

    this.load();
  }

  load() {
    this.labelService.get(this.number)
      .then((resp) => {
        this.label = resp.data;

        this.labelService.members(resp.data.number)
          .then((members) => {
            if (members.status !== 204) {
              this.members = members.data;
            } else {
              this.members = {
                items: [],
                total: 0
              };
            }
          });
      });
  }

  remove() {
    this.labelService.remove(this.number)
      .then(() => this.$location.path('/grupper'));
  }

  assignMember() {
    if (this.recipientNumber) {
      this.labelService.assignMember(this.number, this.recipientNumber)
        .then(() => this.load());
    }
  }

  removeMember(number) {
    this.labelService.removeMember(this.number, number)
      .then(() => this.load());
  }

  export() {
    this.reportService.availableColumns('recipients')
      .then((resp) => {
        if (resp && resp.data) {
          this.reportService.download('recipients', {
            format: 'XLS',
            columns: resp.data.map(data => data.key).join(','),
            labelNumber: this.label.number
          });
        }
      });
  }
}

LabelEdit.$inject = ['$location', '$routeParams', 'labelService', 'recipientService', 'reportService'];

const labelEdit = {
  controller: LabelEdit,
  template: `
    <h2>{{ $ctrl.label.name }} <small>({{ $ctrl.members.total }})</small></h2>

    <form name="recipientForm" ng-submit="$ctrl.assignMember()" novalidate>
      <fieldset class="hide-on-print">
        <h3 class="subheader">Legg til i gruppe</h3>

        <div>
          <input type="text" id="recipientName" autofocus>
        </div>

        <button type="submit" class="button" ng-disabled="recipientForm.$invalid">Lagre</button>
      </fieldset>
    </form>

    <div class="row" ng-show="$ctrl.members.items.length">
      <div class="large-12 columns">
        <a role="button" class="button secondary" href="#/rapport/omsetning?gruppe={{ $ctrl.label.number }}">Omsetning</a>
        <a role="button" class="button secondary" href ng-click="$ctrl.export()"><i class="fa fa-file-excel-o"></i> Eksport til Excel</a>
      </div>
    </div>

    <table ng-show="$ctrl.members.items.length">
      <thead>
        <tr>
          <th>Medlem</th>
          <th class="right-align">Utest&aring;ende</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="member in $ctrl.members.items track by $index">
          <td>
            <a href="#/kunde/{{ member.recipientNumber }}">
              {{ member.name }}
            </a>
          </td>
          <td class="right-align nowrap">
            {{ member.balance | crowns }}
          </td>
          <td class="right-align">
            <a role="button" class="button small alert" ng-click="$ctrl.removeMember(member.recipientNumber)" href>Fjern fra gruppe</a>
          </td>
        </tr>
      </tbody>
    </table>

    <a role="button" href="#/grupper" class="button secondary">Avbryt</a>
    <a role="button" href ng-click="confirmDelete = true" class="button alert">Fjern</a>

    <div modal visible="confirmDelete">
      <p>Bekreft fjerning av gruppe</p>
      <a role="button" class="alert button " ng-click="$ctrl.remove()" href>Fjern</a>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('labelEdit', labelEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/grupper/:number', {
        title: 'Gruppe',
        template: '<label-edit />',
        secure: true
      });
  });
